import { getCompanyPermissionMode } from '@/api/userDataPermission';

export default {
  data() { return { companyPermissionMode: null }; },
  created() { this.loadCompanyPermissionMode(); },
  activated() { this.loadCompanyPermissionMode(); },
  methods: {
    async loadCompanyPermissionMode() {
      if (this._loadingPermissionMode) return;
      this._loadingPermissionMode = true;
      try {
        this.companyPermissionMode = await getCompanyPermissionMode();
        if (this.companyPermissionMode === 'USER' && this.chooseindex == 1 && this.$options.name === 'qxsz') {
          this.chooseindex = 0;
          this.leftlist();
        }
      } catch (error) {
        this.companyPermissionMode = null;
        this.$message.error(error.message);
      } finally { this._loadingPermissionMode = false; }
    }
  }
};
